import React from "react";
import { StyledPricing } from "../components/Styles";
import Consultation from "../components/Consultation";
import TrueIcon from "../components/Icons/True";
import { useTranslation } from "react-i18next";

const MobileAppPricing = () => {
  const { i18n, t } = useTranslation();

  /* ---------------------------
     Factors List (Description)
  ---------------------------- */
  const factors = ["type", "features", "platform", "security"];

  /* ---------------------------
     Pricing Table Config
  ---------------------------- */
  const tableRows = [
    ["platform", "androidIos", "androidIos"],
    ["screens", "upto5", "upto15"],
    ["backend", "included", "included"],
    ["design", "templates", "customDesign"],
    ["admin", "notIncluded", "webPanel"],
    ["support", "threeMonths", "sixMonths"],
    ["delivery", "twoThree", "threeFour"],
    ["thirdParty", "two", "five"],
    ["auth", "notIncluded", "emailSms"],
  ];

  return (
    <StyledPricing.Container>
      <StyledPricing.Description>
        <p>
          <StyledPricing.Title lang={i18n.language}>
            {t("mobilePricing.title")}
          </StyledPricing.Title>

          {t("mobilePricing.intro")}
          {t("mobilePricing.factorsTitle")}

          <ul>
            {factors.map((factor) => (
              <li key={factor}>
                <TrueIcon color={"#caa037"} width={14} height={14} />
                <span lang={i18n.language}>
                  {t(`mobilePricing.factors.${factor}`)}
                </span>
              </li>
            ))}
          </ul>

          {t("mobilePricing.proposal")}
          <br />
          {t("mobilePricing.conclusion")}
        </p>
      </StyledPricing.Description>

      <StyledPricing.PricingTable>
        <StyledPricing.Table>
          <thead>
            <StyledPricing.HeaderRow>
              <StyledPricing.HeaderCell />
              <StyledPricing.HeaderCell>
                {t("mobilePricing.table.basic")}
              </StyledPricing.HeaderCell>
              <StyledPricing.HeaderCell>
                {t("mobilePricing.table.standard")}
              </StyledPricing.HeaderCell>
            </StyledPricing.HeaderRow>
          </thead>

          <tbody>
            {tableRows.map(([label, basic, standard]) => (
              <StyledPricing.Row key={label}>
                <StyledPricing.Cell lang={i18n.language}>
                  {t(`mobilePricing.table.${label}`)}
                  <span></span>
                </StyledPricing.Cell>

                <StyledPricing.Cell>
                  {t(`mobilePricing.table.${basic}`)}
                </StyledPricing.Cell>

                <StyledPricing.Cell>
                  {t(`mobilePricing.table.${standard}`)}
                </StyledPricing.Cell>
              </StyledPricing.Row>
            ))}

            {/* Price Row */}
            <StyledPricing.Row>
              <StyledPricing.Cell />
              <StyledPricing.Cell>{t("mobilePricing.table.price-basic")}</StyledPricing.Cell>
              <StyledPricing.Cell>{t("mobilePricing.table.price-standard")}</StyledPricing.Cell>
            </StyledPricing.Row>
          </tbody>
        </StyledPricing.Table>
      </StyledPricing.PricingTable>

      <div>
        <Consultation
          text={
            <>
              {t("customPackage")}
              <br />
              {t("contactus")}
            </>
          }
        />
      </div>
    </StyledPricing.Container>
  );
};

export default MobileAppPricing;